import { useState } from 'react';
import { 
  Select, 
  MenuItem, 
  OutlinedInput, 
  FormControl, 
  Typography, 
  FormHelperText 
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const CustomSelect = ({
  label,
  required = false,
  error = false,
  helperText,
  fullWidth = false,
  width,
  maxWidth,
  children,
  sx = {},
  display,
  MenuProps = {},
  ...props
}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  
  // Calculate dynamic width
  const dynamicWidth = fullWidth ? '100%' : (width || 220);
  const dynamicMaxWidth = fullWidth ? '100%' : (maxWidth || width || 220);
  
  // Merge MenuProps
  const mergedMenuProps = {
    ...MenuProps,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left',
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left',
    },
    PaperProps: {
      sx: {
        minWidth: 0, // Allow menu to size naturally
        width: 'auto', // Auto width based on content
        maxWidth: '100%', // But not wider than container
        boxShadow: 'none',
        borderRadius: '0 0 8px 8px',
        overflow: 'hidden',
        fontSize: '14px',
        border: '1px solid #ccc',
        borderTop: 'none',
        '& .MuiMenu-list': {
          padding: 0,
        },
        '& .MuiMenuItem-root': {
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          fontSize: '14px',
          minHeight: 'auto',
          padding: '8px 12px',
        },
        '& .Mui-selected': {
          backgroundColor: '#F7F7F7 !important',
          color:'#666666',
          textTransform: 'capitalize',
          fontSize: '14px',
        },
        ...MenuProps.PaperProps?.sx
      },
      ...MenuProps.PaperProps
    }
  };

  const selectComponent = (
    <Select
      {...props}
      open={menuOpen}
      onOpen={() => setMenuOpen(true)}
      onClose={() => setMenuOpen(false)}
      IconComponent={KeyboardArrowDownIcon}
      input={
        <OutlinedInput
          error={error}
          sx={{
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: error ? '#d32f2f' : '#ccc',
              borderWidth: '1px',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: error ? '#d32f2f !important' : '#ccc !important',
              borderWidth: '1px',
            },
          }}
        />
      }
      sx={{
        '&.MuiOutlinedInput-root': {
          borderRadius: menuOpen ? '8px 8px 0px 0px': '8px',
          boxShadow: 'none',
          minHeight: '40px', // Match TextField height
          height: '40px', // Fixed height to match TextField
        },
        '& .MuiSelect-select': {
          padding: '8px 12px', // Match TextField padding
          display: 'flex',
          alignItems: 'center',
          fontSize: '16px',
          fontFamily: 'Lato, sans-serif',
          color: '#666666',
        },
        '& .Mui-selected': {
          backgroundColor: '#F7F7F7',
        },
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: error ? '#d32f2f' : '#ccc',
          borderWidth: '1px',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: error ? '#d32f2f !important' : '#ccc !important',
          borderWidth: '1px',
        },
        width: dynamicWidth,
        maxWidth: dynamicMaxWidth,
        ...sx,
      }}
      MenuProps={mergedMenuProps}
    >
      {children}
    </Select>
  );

  if (label || helperText) {
    return (
      <FormControl 
        fullWidth={fullWidth} 
        error={error}
        sx={{ 
          width: fullWidth ? '100%' : dynamicWidth,
          maxWidth: fullWidth ? '100%' : dynamicMaxWidth,
          // visibility: display || 'visible',
          display: display || 'block',
        }}
      >
        {label && (
          <Typography variant='labelD' sx={{ color: '#666'}} component="legend" required={required}>
            {label}
          </Typography>
        )}
        {selectComponent}
        {helperText && (
          <FormHelperText>
            {helperText}
          </FormHelperText>
        )}
      </FormControl>
    );
  }

  return selectComponent;
};

export default CustomSelect;
